<template>
  <div
    class="d-print-none d-flex flex-column flex-shrink-0 px-3 pb-3 bg-light"
    style="width: 280px; border-right: 1px solid rgba(0, 0, 0, 0.125); padding-top: 21px"
  >
    <router-link to="/home" class="d-flex align-items-center link-dark text-decoration-none mt-0" activeClass="">
      <div class="w-100 text-center">
        <img src="@/assets/bv-logo.svg" class="mb-2" style="width: 150px" />
      </div>
    </router-link>
    <!-- ACTIVE PROJECT SELECTOR -->
    <div class="row mt-4">
      <div class="col-auto text-muted pr-0"><small>Ausgewähltes Projekt</small></div>

      <div class="col ps-0">
        <hr class="mb-0 navbar-vertical-divider" />
      </div>
    </div>
    <div class="row">
      <div class="col mt-3 text-center">
        <img
          :src="projectStore.currentProjectPicture"
          v-if="projectStore.currentProjectPicture"
          style="max-width: 150px"
        />
      </div>
      <div
        class="mt-3 mr-3 d-flex p-2 flex-row align-items-begin shadow-muted-super"
        style="margin-left: 14px; padding-left: 20px; border: 1px solid #f0f0f0; background: white; width: 400px"
      >
        <div class="col p-0">
          <small>
            {{ projectStore.activeProject.ProjectIdentifier }}
            <b-icon scale="2" icon="dot"></b-icon>
            {{ projectStore.activeProject.Name }}
          </small>
        </div>
        <div class="col-auto p-0">
          <b-icon
            variant=""
            class="no-outline"
            icon="chevron-down"
            role="button"
            style="height: 15px; width: 15px"
            @click="openSelectProjectModal"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-2 mt-4">
      <div class="col-auto text-muted pr-0" @click="toggleNavigation(true)"><small>Navigation</small></div>
      <div class="col ps-0">
        <hr class="mb-0 navbar-vertical-divider" />
      </div>
      <div class="col-auto text-muted pl-0">
        <small><b-icon icon="chevron-double-left" class="action-button" @click="toggleNavigation(true)" /></small>
      </div>
    </div>

    <ul class="nav nav-pills flex-column mb-auto">
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          to="/settings"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <!-- v-if="$root.$user.roles.includes('Admin')" -->
          <b-icon class="me-2" icon="compass"></b-icon>
          Projektdaten
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          to="/budget"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="calculator"></b-icon>
          Projektbudget
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          to="/allocationunits"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="card-list"></b-icon>
          Vergabeeinheiten
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/changemanagement"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="clipboard-plus"></b-icon>
          Änderungsmanagement
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/preiserfassung"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="gem"></b-icon>
          Preiserfassung
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/orders"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="file-earmark"></b-icon>
          Aufträge
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/invoices"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <svg
            width="20"
            height="20"
            fill="currentColor"
            class="bi-file-earmark me-2 b-icon bi"
            viewBox="0 0 16 16"
            version="1.1"
            id="svg4"
          >
            <path
              d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
              id="path2"
            />
            <path
              d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
              id="path2-4"
            />
          </svg>
          Abrechnung
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          :to="'/risks'"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="lightning"></b-icon>
          Chancen & Risiken
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/reports"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="graph-up"></b-icon>
          Berichte
        </router-link>
      </li>
      <!--
      <li class="nav-item">
        <router-link
          v-bind:exact="true"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/abnahmen"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="check2-circle"></b-icon>
          Abnahmen
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="false"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/cashflow"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="list-nested"></b-icon>
          Mittelabfluss
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-bind:exact="true"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/nachkalkulation"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="calculator-fill"></b-icon>
          Nachkalkulation
        </router-link>
      </li>-->
      <li class="nav-item">
        <router-link
          v-bind:exact="true"
          class="nav-link link-dark"
          :class="{ disabled: projectStore.activeProject.State == 0 }"
          to="/completion"
          activeClass="main-nav-active"
          exact-active-class="main-nav-active"
        >
          <b-icon class="me-2" icon="trophy"></b-icon>
          Projektabschluss
        </router-link>
      </li>
    </ul>
    <div class="row">
      <div class="col text-center">
        <!--
        <b-link class="ml-2 text-dark" href="https://www.bauvisor.de/tutorial/">
          <b-icon icon="question-circle" variant="dark" class="" />
          Tutorial
        </b-link>-->
        <b-link style="display:inline" class="nav-link link-dark" href="https://www.bauvisor.de/tutorial/">
          <!-- v-if="$root.$user.roles.includes('Admin')" -->
          <b-icon class="me-2" icon="book"></b-icon>
          Hilfe
        </b-link>
        <b-link
          v-if="$root.$user.isSuperAdmin"
          style="display:inline"
          class="nav-link link-dark"
          :href="
            'https://docs.bvapp.de/apps/files/files?dir=/' +
              projectStore.activeProject.ProjectIdentifier +
              ' ' +
              projectStore.activeProject.Name
          "
          target="_blank"
        >
          <b-icon class="me-2" icon="files"></b-icon>
          Dokumente
        </b-link>
      </div>
    </div>
    <div class="row">
      <div class="col ps-0 text-center">
        <hr class="mb-3" />
        <DateString />
      </div>
    </div>

    <div class="row mb-2">
      <div class="col ps-0">
        <hr class="mb-0" />
      </div>
    </div>
    <b-dropdown dropup variant="light" menu-class="w-100" class="profile-menu" id="">
      <template #button-content>
        <div class="row align-items-center text-center d-flex justify-content-center">
          <!--- <img :src="getAvatarImage()" alt="" width="32" height="32" class="rounded-circle mr-3" /> --->
          <b-avatar
            variant="primary-semi-light"
            class="mr-3"
            :text="$auth.user.name.substring(0, 2)"
            :src="$root.$user.picture"
            :title="
              $root.$user.sub +
                ' | ' +
                projectStore.activeProject.DbId +
                ' | Reader: ' +
                $root.$user.isReaderOnly +
                ' | Planer:' +
                $root.$user.isPlaner +
                ' | Admin:' +
                $root.$user.isAdmin +
                ' | SU:' +
                $root.$user.isSuperAdmin +
                ' --------------- ' +
                JSON.stringify($root.$user)
            "
          ></b-avatar>
          <span class="" style="padding-right: 10px">
            <strong>{{ $auth.user.name }}</strong>
          </span>
          <b-icon icon="chevron-up" style="height: 10px; width: 10px" />
        </div>
      </template>
      <b-dropdown-header class="text-center">
        <a href="https://www.bauvisor.com"><img src="@/assets/bv-logo.svg" style="width: 150px" /></a>
      </b-dropdown-header>
      <b-dropdown-divider />
      <b-dropdown-item to="/profile" class="condensed">
        <b-icon icon="file-person" class="mr-2 text-muted" />
        Mein Profil
      </b-dropdown-item>
      <b-dropdown-item href="https://www.bauvisor.de/tutorial/" target="_blank" class="condensed">
        <b-icon icon="question-circle" class="mr-2 text-muted" />
        Tutorial
      </b-dropdown-item>
      <b-dropdown-divider v-if="$root.$user.isCustomerAdmin"></b-dropdown-divider>
      <b-dropdown-item
        v-if="$root.$user.isCustomerAdmin"
        href="https://admin.bauvisor.com/"
        target="_blank"
        class="condensed"
      >
        <b-icon icon="gear" class="mr-2 text-muted" />
        Kundenverwaltung
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="logout" class="condensed">
        <img src="@/assets/sign-out.svg" width="16" height="16" class="mr-2 text-muted" />
        Logout
      </b-dropdown-item>
    </b-dropdown>
    <b-modal
      @ok="switchProject"
      @shown="$refs.projectSearchField.focus()"
      okTitle="Auswählen"
      cancelTitle="Abbrechen"
      cancelVariant="dark"
      id="selectProjectModal"
      size="xl"
      title="Projekt wählen"
    >
      <input
        placeholder="Suchbegriff eingeben..."
        class="form-control block mb-3"
        ref="projectSearchField"
        v-model="projectSearchText"
        type="search"
      />
      <b-list-group style="height: 500px; overflow-y: auto">
        <b-list-group-item
          href="#"
          :active="projectToSwitchTo == project.DbId"
          class="flex-column align-items-start"
          v-for="project in filteredProjects"
          :key="project.DbId"
          @click="selectProject(project.DbId)"
          @dblclick.stop="selectProjectAndClose(project.DbId)"
        >
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">
              {{ project.ProjectIdentifier }} {{ project.Name }}
              <b-badge
                :variant="project.State == 0 ? 'primary' : project.State == 1 ? 'secondary' : 'light'"
                style="vertical-align: middle; padding-top: 4px"
              >
                {{ project.State == 0 ? 'Kalkulation' : project.State == 1 ? 'Ausführung' : 'Archiviert' }}
              </b-badge>
            </h6>
            <b-badge v-if="project.DbId == projectStore.activeProject.DbId" variant="light" class="my-auto">
              AKTIV
            </b-badge>
          </div>

          <p class="mb-1">
            <small>
              Auftraggeber: {{ project.CustomerText ? project.CustomerText : '(leer)' }}
              <b-icon scale="2" icon="dot"></b-icon>
              Projektleiter: {{ project.ProjectLeadInternal }}
              <b-icon scale="2" icon="dot"></b-icon>
              Projektstart: {{ $utils.SQLDateToGermanDate(project.ProjectStartDate) }}
            </small>
          </p>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import DateString from '@/components/DateString';
import projectStore from '@/store/Projects';
import userService from '@/service/UserService';

import AppState from '@/store/App';

export default {
  computed: {
    filteredProjects() {
      if (!this.projectSearchText) return this.projectStore.projects;

      return this.projectStore.projects.filter(
        x =>
          x.Name.toLowerCase().includes(this.projectSearchText.toLowerCase()) ||
          x.ProjectIdentifier.toLowerCase().includes(this.projectSearchText.toLowerCase())
      );
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      projectStore.loadProjectPicture();
      this.onResize();

      //this.$eventBus.$emit('projectSwitched', projectStore.activeProject);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    toggleNavigation(forced = false) {
      console.log('Toggle!', AppState.showNav, AppState.showNavForced);
      this.$nextTick(() => {
        AppState.showNav = !AppState.showNav;
        AppState.showNavForced = forced;
      });
    },

    onResize() {
      //console.log('Resize!', AppState.showNav
      /*, AppState.showNavForced);
      this.$nextTick(() => {
        if (window.innerWidth < 1000) {
          //AppState.showNav = false;
        } else {
          AppState.showNav = true;
        }
      });*/
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    selectProject(id) {
      this.projectToSwitchTo = id;
    },
    selectProjectAndClose(id) {
      this.projectToSwitchTo = id;
      this.$bvModal.hide('selectProjectModal');
      this.switchProject();
    },
    openSelectProjectModal() {
      this.projectToSwitchTo = projectStore.activeProject.DbId;
      this.$bvModal.show('selectProjectModal');
    },
    switchProject() {
      if (this.projectToSwitchTo && this.projectToSwitchTo !== projectStore.activeProject.DbId) {
        projectStore.activeProject = projectStore.projects.find(x => x.DbId == this.projectToSwitchTo);

        if (projectStore.activeProject && projectStore.activeProject.State == 2) {
          this.$root.$user.isPlaner = false;
          this.$root.$user.isAdmin = false;
          this.$root.$user.isSuperAdmin = false;
        } else {
          this.$root.$user.isPlaner = projectStore.activeProject && projectStore.activeProject.IsPlaner == 'true';
          this.$root.$user.isAdmin = projectStore.activeProject && projectStore.activeProject.IsAdmin == 'true';
        }
        localStorage.setItem('activeProject', projectStore.activeProject.DbId);
        userService.setActiveProjectId(projectStore.activeProject.DbId);

        projectStore.loadProjectPicture();

        this.$eventBus.$emit('projectSwitched', projectStore.activeProject);

        if (this.$router.currentRoute.path !== '/settings/project') this.$router.push('/settings');
      }
    }
  },
  data() {
    return {
      AppState,
      projectSearchText: null,
      appTitle: process.env.VUE_APP_NAME,
      projectStore,
      projectToSwitchTo: null,
      projectPicture: null
      /*
      menu: [
        {
          href: '/home',
          title: 'Dashboard',
          icon: 'clipboard-data',
          exact: true
        },
        {
          href: '/controlling',
          title: 'Kostenüberwachung',
          icon: 'calculator'
        },
        {
          href: '/allocationunits',
          title: 'Projektbudget',
          icon: 'building'
        },
        {
          href: '/orders',
          title: 'Aufträge und Nachträge',
          icon: 'file-earmark'
        },
        {
          href: '/invoices',
          title: 'Rechnungen',
          icon: 'file-earmark'
        },
        {
          href: '/reports',
          title: 'Berichte',
          icon: 'graph-up'
        },
        {
          href: '/projects',
          title: 'Projektverwaltung',
          icon: 'calendar2-range'
        },
        {
          href: '/masterdata',
          title: 'Stammdaten',
          icon: 'journals'
        },
        {
          href: '/users',
          title: 'Benutzerverwaltung',
          icon: 'person'
        },
        {
          href: '/settings',
          title: 'Einstellungen',
          icon: 'tools'
        }
      ]*/
    };
  },
  components: {
    DateString
  }
};
</script>

<style>
.navbar-vertical-divider {
  margin-top: 0.755rem;
}

#dropdown-user > button {
  text-align: left !important;
}

.profile-menu .dropdown-toggle::after {
  display: none !important;
}

.modal-xl {
  width: 600px !important;
}

.no-outline:focus {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.main-nav-active,
.main-nav-active:hover {
  color: #fff !important;
  background-color: var(--bauvisor-primary) !important;
}

.link-dark {
  color: #666;
}

.nav-link.link-dark.disabled {
  color: #bbb;
}

.condensed > .dropdown-item {
  padding-left: 15px;
}
</style>
